<template>
	<div id="plans" class="pb-sm-2">
		<v-fab-transition>
			<v-btn
				v-if="
					!isSelectedDayWeekend && (
          (
						!loading &&
						moment(selectedMonth, 'YYYY-MM').diff(moment().format('YYYY-MM'), 'months') > 0 &&
						moment(selectedMonth, 'YYYY-MM').diff(moment(activeRegionPlan.fromDate).format('YYYY-MM'), 'months') === 0 &&
						!weeklyPlan &&
          lockPlanBeforeDays === undefined
					) ||
					(
						!loading &&
						weeklyPlan &&
						lockPlanBeforeDays === 0 &&
						moment(selectedDay).isSameOrAfter(moment(), 'day')
					)
					||
          (
						!loading &&
						!weeklyPlan &&
						lockPlanBeforeDays === 0 &&
						moment(selectedDay).isSameOrAfter(moment(), 'day')
					)
					|| (!weeklyPlan && (lockPlanBeforeDays === null || lockPlanBeforeDays === undefined) && moment(selectedDay).isAfter(moment(moment().endOf('month')), 'day'))
          ||
					(weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(endOfCurrentWeek), 'day')) ||
          (lockPlanBeforeDays > 0 && moment(selectedDay).isSameOrAfter(moment().add(lockPlanBeforeDays, 'day'), 'day'))
					)
				"
				fab
				fixed
				bottom
				:right="$i18n.locale !== 'ar'"
                :left="$i18n.locale === 'ar'"
				direction="left"
				color="primary"
				:class="['mb-15', { 'sale-system-add-fab': usePrices }]"
				@click="planningVisitSheet = true"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-fab-transition>

		<!-- delete dialog declaered here to use it as ref -->
        <delete-dialog ref="DeleteDialog" @on-delete="fetchPlannedRegions">
            <template v-slot:default>
				<p
					class="mb-0 text-body-1"
					v-html="$T('messages.are-you-sure-you-want-to-delete-$', { text: $T('the-planned-visit') })"
				/>
            </template>
        </delete-dialog>

		<!-- add sheet -->
		<v-bottom-sheet v-model="planningVisitSheet" persistent>
			<v-card>
				<v-toolbar dark flat color="primary" class="text-uppercase">
					<v-spacer/>

					<v-spacer/>
					<v-toolbar-items text>
						<v-btn small text @click="planningVisitSheet = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-form @submit.prevent="submit" ref="form" :disabled="submitLoading">
                    <!-- card content -->
                    <v-card-text class="pb-0">
						<v-row dense>
							<!-- region -->
							<v-col cols="12">
								<v-autocomplete
									v-model="sheetData.regionId"
									:items="regions"
									item-text="name"
									item-value="id"
									:multiple="!plannedRegionId"
									:label="$T('inputs.region')"
									chips
									small-chips
									deletable-chips
									:rules="rules.required"
									hide-details="auto"
									:disabled="submitLoading"
								></v-autocomplete>
							</v-col>

							<!-- date -->
							<v-col md="6" cols="12" class="d-flex">
								<div class="d-flex flex-column align-start justify-start me-1">
									<v-icon size="24" class="mx-1" :color="isHoliday === 'error' ? '#F4511E' : ''">mdi-calendar</v-icon>
									<span v-if="isHoliday === 'error'" style="color: #F4511E" class=" fs-sm">Holiday </span>
								</div>
								<v-menu
									v-model="dateMenu"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="sheetData.date"
											:label="$T('inputs.date')"
											:rules="rules.required"
											hide-details="auto"
											readonly
											v-bind="attrs"
											v-on="on"
                      disabled
										></v-text-field>
									</template>

									<v-date-picker
										v-model="sheetData.date"
										:min="moment().format('YYYY-MM-DD')"
										@input="dateMenu = false"
										@change="getHoliday(sheetData.date)"
									></v-date-picker>
								</v-menu>
							</v-col>

							<!-- notes -->
							<v-col cols="12">
								<v-textarea
									v-model="sheetData.notes"
									:label="$T('inputs.notes')"
									rows="2"
									auto-grow
									hide-details="auto"
									:disabled="submitLoading"
								></v-textarea>
							</v-col>
						</v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
						<v-btn
							color="success"
							text
							type="submit"
							:loading="submitLoading"
							:disabled="submitLoading"
						>
							{{$T('save')}}
						</v-btn>
						<v-btn color="grey darken-1" text @click="planningVisitSheet = false">
							{{$T('close')}}
						</v-btn>
					</v-card-actions>
                </v-form>
			</v-card>
		</v-bottom-sheet>

		<!-- filter -->
        <v-card flat color="lightgray">
            <!-- date -->
            <v-card-text class="d-flex justify-space-between align-center">
                <!-- date dialog -->
                <v-dialog
					v-model="dialog"
                    ref="dialog"
                    :return-value.sync="selectedMonth"
                    persistent
                    max-width="300px"
                >
                    <!-- date text -->
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex justify-space-between align-center primary--text "
                        >
                            <div class="d-flex align-center">
                                <v-icon class="me-2" color="primary">mdi-calendar</v-icon>
                                <span class="text-h5 me-2">{{ dateHeaderLabel }}</span>
								<span class="text-subtitle-2 align-self-end">{{moment(selectedDay || selectedMonth).format('YYYY')}}</span>
                            </div>
                        </div>
                    </template>
                    <!-- dialog date picker -->
                    <v-date-picker
                        v-model="selectedMonth"
                        full-width
                        picker-date
						type="month"
                        :max="moment().add(1, 'month').format('YYYY-MM-DD')"
						@change="selectedDay = undefined"
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="dialog = false"
                        >
                            {{$T('cancel')}}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="update()"
                        >
                            {{$T('ok')}}
                        </v-btn>
                    </v-date-picker>
                </v-dialog>

				<!-- today button -->
				<v-btn
					text
					small
					color="primary"
					@click="goToTodayDate"
				>
					{{$T('components.today')}}
				</v-btn>
            </v-card-text>
        </v-card>

		<!-- date picker -->
		<div class="d-flex align-center mb-4">
			<v-btn
				depressed
				min-width="0"
				height="48"
				class="mx-2 py-0 px-2 rounded-sm transparent"
				:class="{ secondary: !selectedDay }"
				@click="selectedDay = undefined"
			>{{$T('all')}}</v-btn>
			<v-day-date
				v-if="weeklyPlan"
				:value="selectedDay"
				:month="selectedMonth"
				:max-width="
					$vuetify.breakpoint.width -
					(isTouchDevice ? 52 : 70) -
					($i18n.locale === 'ar' ? 34 : 10)
				"
				:optional="false"
				@change="onSelectedDayChange"
				:disabled="loading"
			></v-day-date>

			<v-month-days
				v-else
				v-model="selectedDay"
				:month="selectedMonth"
				:vacations="vacations"
				:vacation-day-details="vacationsDayDetails"
				:max-width="
					$vuetify.breakpoint.width -
					(isTouchDevice ? 52 : 70) -
					($i18n.locale === 'ar' ? 34 : 10)
				"
			></v-month-days>
		</div>

		<!-- cards -->
		<loader v-if="loading"/>
		<v-row v-else :no-gutters="$vuetify.breakpoint.xs" dense class="mx-2">
			<v-col
				v-for="(plannedRegion, index) in filteredPlanningVisits"
				:key="plannedRegion.id"
				cols="12"
				class="planned-visit__container mb-3"
				:class="{ 'mb-16': index === filteredPlanningVisits.length - 1 }"
			>
				<!-- deleteFab -->
				<v-fab-transition>
					<v-btn
						v-if="deleteButtonFab && plannedRegionId === plannedRegion.id"
						fab
						absolute
						left
						dark
						small
						text
						:width="14"
						color="red darken-2"
						class="planned-visit__action-btn"
					>
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</v-fab-transition>
				<v-card
					v-touch="
						isPlannedRegionOutOfActivePlan(plannedRegion.id)
						? {
							move: (e) => { plannedRegionId = plannedRegion.id; touchMove(e); },
							end: (e) => { endOffset(e) }
						}
						: {}
					"
					outlined
					class="planned-visit__card rounded-lg"
					:style="
						(deleteButtonFab || editButtonFab) && plannedRegionId === plannedRegion.id
							? { transform: `translateX(${touchSwipeOffset}px)` }
							: null
					"
				>
					<v-card-text class="pa-3">
						<!-- region name + date -->
						<div class="d-flex align-center justify-space-between">
							<span class="text-subtitle-1 font-weight-bold primary--text">
								{{ getRegionById(plannedRegion.regionId)?.name }}
							</span>

							<v-chip
								small
								label
								:color="
									plannedRegion.isVisited
										? 'green lighten-5'
										: moment(plannedRegion.date).diff(moment(), 'days') < 0
											? 'red lighten-5'
											: 'orange lighten-5'
								"
								:text-color="
									plannedRegion.isVisited
										? 'green darken-2'
										: moment(plannedRegion.date).diff(moment(), 'days') < 0
											? 'red darken-1'
											: 'orange darken-1'
								"
								class="rounded-lg font-weight-medium"
							>
								<v-icon left x-small>mdi-calendar</v-icon>
								{{ moment(plannedRegion.date).format('DD MMMM YYYY') }}
							</v-chip>
						</div>

						<!-- notes -->
						<div v-if="plannedRegion.notes" class="d-flex align-start mt-2">
							<span class="grey--text text-body-2 me-4">{{ $T('inputs.notes') }}</span>
							<span class="grey--text text--darken-3 text-body-2">{{ plannedRegion.notes }}</span>
						</div>

						<!-- delete/edit buttons for planning state -->
						<v-row
							dense
							class="mt-1"
							v-if="
								(
									!loading &&
									moment(selectedMonth, 'YYYY-MM').diff(moment().format('YYYY-MM'), 'months') > 0 &&
									moment(selectedMonth, 'YYYY-MM').diff(moment(activeRegionPlan.fromDate).format('YYYY-MM'), 'months') === 0 &&
									!weeklyPlan
								)
								||
								(
									!loading &&
									weeklyPlan &&
									lockPlanBeforeDays === 0 &&
									moment(selectedDay).isSameOrAfter(moment(), 'day')
								)
								||
								(weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(endOfCurrentWeek), 'day'))
								||
								(!weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(moment().endOf('month')), 'day'))
								||
								(lockPlanBeforeDays !== null && moment(selectedDay).isSameOrAfter(moment(activeRegionPlan.fromDate).add(lockPlanBeforeDays, 'day'), 'day'))
						"
						>
							<v-col cols="6">
								<v-btn
									depressed
									block
									class="orange--text text--darken-1 rounded-lg"
									@click="plannedRegionId = plannedRegion.id; fillDateToEdit()"
								>
									<v-icon left small>mdi-pencil-outline</v-icon>
									{{ $T('edit') }}
								</v-btn>
							</v-col>
							<v-col cols="6">
								<v-btn
									depressed
									block
									class="red--text text--darken-1 rounded-lg"
									@click="
										plannedRegionId = plannedRegion.id;
										$refs.DeleteDialog.activeDialog(plannedRegionId, 'plannedRegions')
									"
								>
									<v-icon left small>mdi-trash-can-outline</v-icon>
									{{ $T('delete') }}
								</v-btn>
							</v-col>

						</v-row>
					</v-card-text>
				</v-card>

				<!-- EditFab -->
				<v-fab-transition>
					<v-btn
						v-if="editButtonFab && plannedRegionId === plannedRegion.id"
						fab
						absolute
						right
						dark
						small
						text
						:width="14"
						color="success darken-2"
						class="planned-visit__action-btn"
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</v-fab-transition>
			</v-col>

			<v-col
				v-if="!filteredPlanningVisits.length"
				cols="12"
				class="d-flex flex-column justify-center align-center grey--text text-body-1"
				style="height: 45vh"
			>
				<v-icon x-large class="mb-3">mdi-alert-circle-outline</v-icon>
				{{$T('no-planned-visits-for-this-day')}}
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import DeleteDialog from '../components/DeleteDialog'
import { mapGetters, mapState } from 'vuex';
import { isTouchDevice, getWeekRange, getDateColor } from '@/helpers/functions'
import rules from '@/helpers/validation rules';
import moment from 'moment';
import { usePrices } from '@/configs/general.configs'
import VDayDate from '@/components/VDayDate.vue';
import VMonthDays from '@/components/VMonthDays.vue';

export default {
	name: 'RegionPlans',

	components: {
		DeleteDialog,
		VDayDate,
		Loader,
		VMonthDays
	},

	data: () => ({
		// helpers
		loading: false,
		submitLoading: false,

		dialog: false,
		planningVisitSheet: false,

		dateMenu: null,
		selectedDay: moment().format('YYYY-MM-DD'),
		selectedMonth: moment().format('YYYY-MM'),

		rules,

		// configs
		usePrices,

		// swipe card
		plannedRegionId: null,
		touchSwipeOffset: 0,
		deleteButtonFab: false,
		editButtonFab: false,

		sheetData: {
			regionId: null,
			date: moment().format('YYYY-MM-DD'),
			notes: null,
		},

		editingRegionPlanId: null,

		isHoliday: null
	}),

	watch: {
		planningVisitSheet(newVal) {
			if (!newVal) {
				if (this.$refs.form) this.$refs.form.resetValidation();
				this.sheetData.regionId = null;
				this.sheetData.notes = null;

				this.plannedRegionId = null;
				this.editingRegionPlanId = null;
			} else {
				this.sheetData.date = this.selectedDay || moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD');
			}
		}
	},

	computed: {
		dateHeaderLabel() {
			if (!this.selectedDay) return moment(this.selectedMonth).format('MMMM');

			const isToday = this.selectedDay === moment().format('YYYY-MM-DD');
			const dayLabel = isToday ? this.$T('components.today') : moment(this.selectedDay, 'YYYY-MM-DD').format('dddd');

			return `${dayLabel}, ${moment(this.selectedDay, 'YYYY-MM-DD').format('DD MMMM')}`;
		},

		...mapState({
			self: state => state.auth.self,
			regionPlans: state => state.regionPlans.regionPlans,
			plannedRegions: state => state.plannedRegions.plannedRegions,
			activeRegionPlan: state => state.regionPlans.activeRegionPlan,
			regions: state => state.regions.regions,
			vacations: state => state.vacations.vacations,
			vacationsDayDetails: state => state.vacations.vacationsDayDetails,
			weeklyPlan: state => state.configurations.weeklyPlan,
			lockPlanBeforeDays: state => state.configurations.lockPlanBeforeDays,
			weekendCompany: state => state.configurations.systemConfigValue?.properties?.find(c => c.key === 'weekend')?.value
		}),

		...mapGetters({
			getRegionById: 'regions/getRegionById',
			getPlannedRegionById: 'plannedRegions/getPlannedRegionById',
		}),

		filteredPlanningVisits() {
			// plannedRegions is already scoped server-side by fromDate/toDate - no need to
			// cross-check against a region plan's own date range (regionPlanId is backend-managed)
			return this.plannedRegions.map(c => ({ ...c, date: moment(c.date).format('YYYY-MM-DD') }))
				.filter(c => {
					if (!this.selectedDay) return c.date.includes(this.selectedMonth);
					else return c.date === this.selectedDay;
				}).sort((a, b) => {
					const diff = moment(a.date).diff(b.date, 'days');
					if (diff > 0) return -1;
					else if (diff < 0) return 1;
					return 0;
				});
		},

		isTouchDevice,
		getWeekRange,

		startOfCurrentWeek() {
			return getWeekRange(this.moment())?.start
		},

		endOfCurrentWeek () {
			return getWeekRange(this.moment())?.end
		},

		// true when the selected day falls on the configured weekend day (Sunday=0 ... Saturday=6)
		isSelectedDayWeekend() {
			if (this.weekendCompany === undefined || this.weekendCompany === null || this.weekendCompany === '') return false
			return Boolean(this.selectedDay) && moment(this.selectedDay).day() === Number(this.weekendCompany)
		},
	},

	methods: {
		moment,

		// the day tabs emit change on mount with the day they were given, which would
		// re-trigger the fetch that created() already made
		onSelectedDayChange(date) {
			if (date === this.selectedDay) return;
			this.selectedDay = date;
			this.updateDate();
		},

		update() {
			this.$refs.dialog.save(this.selectedMonth);
			this.selectedDay = moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD');
			this.updateDate()
			this.$store.dispatch('configurations/fetchSystemConfigValue')
		},

		getHoliday (date) {
			const vacationDayDetails = this.vacationsDayDetails
			this.isHoliday = getDateColor(date, this.vacations, { vacationDayDetails })
		},

		updateDate() {
			this.$store.dispatch('plannedRegions/clear')
			this.loading = true;
			this.fetchPlannedRegions(true).finally(() => {
				this.loading = false;
			})
		},

		fetchPlannedRegions(isFirsLoad = false) {
			this.loading = true;

			return this.$store.dispatch('plannedRegions/fetchAll', {
				fromDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.start,
				toDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.end,
			}).finally(() => {
				if (!isFirsLoad) this.loading = false;
			})
		},

		fillDateToEdit() {
			const plannedRegionData = this.getPlannedRegionById(this.plannedRegionId);
			this.sheetData.date = moment(plannedRegionData.date).format('YYYY-MM-DD');
			this.sheetData.regionId = plannedRegionData.regionId;
			this.sheetData.notes = plannedRegionData.notes;
			this.editingRegionPlanId = plannedRegionData.regionPlanId;

			this.planningVisitSheet = true;
		},

		async submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;

				const regionIds = [this.sheetData.regionId].flat();

				const promise = this.plannedRegionId
					? this.$store.dispatch('plannedRegions/update', {
						id: this.plannedRegionId,
						regionPlanId: this.editingRegionPlanId,
						regionId: regionIds[0],
						date: this.sheetData.date,
						note: this.sheetData.notes,
					})
					// regionPlanId is sent as null on create - the backend auto-creates/assigns the region plan
					: regionIds.length > 1
						? this.$store.dispatch('plannedRegions/createBulk', {
							regionPlanId: null,
							regionIds,
							date: this.sheetData.date,
							note: this.sheetData.notes,
							employeeId: this.self.employeeId,
						})
						: this.$store.dispatch('plannedRegions/create', {
							regionPlanId: null,
							regionId: regionIds[0],
							date: this.sheetData.date,
							note: this.sheetData.notes,
						})

				promise.then(() => {
					this.planningVisitSheet = false;
					this.fetchPlannedRegions();
					this.$store.dispatch('regionPlans/fetchAll', { employeeId: this.self.employeeId });
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},

		// swipe card methods
		isPlannedRegionOutOfActivePlan(visitId) {
			const plannedRegionData = this.getPlannedRegionById(visitId);

			const startWeekDay = getWeekRange(this.selectedDay)?.start;

			const activePlan = this.weeklyPlan
				? this.regionPlans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === startWeekDay)
				: this.activeRegionPlan;

			const isCurrentWeek = moment(this.selectedDay).isBetween(this.startOfCurrentWeek, this.endOfCurrentWeek, null, '[]');
			if (this.weeklyPlan && isCurrentWeek) {
				return false;
			}

			if (activePlan && Object.keys(activePlan).length && plannedRegionData) {
				return moment(plannedRegionData.date)
					.isBetween(activePlan?.fromDate, activePlan?.toDate, 'days', '[]')
			} else {
				return false
			}
		},

		touchMove(event) {
			const offset = event.touchmoveX - event.touchstartX;
			this.touchSwipeOffset = offset > -50 && offset < 50 ? offset : Math.sign(offset) * 50;

			if (this.touchSwipeOffset === 50) {
				this.deleteButtonFab = true;
				this.editButtonFab = false;
			} else if (this.touchSwipeOffset === -50) {
				this.deleteButtonFab = false;
				this.editButtonFab = true;
			} else {
				this.deleteButtonFab = false;
				this.editButtonFab = false;
			}
		},
		endOffset() {
			if (this.touchSwipeOffset === 50) {
				this.$refs.DeleteDialog.activeDialog(this.plannedRegionId, 'plannedRegions');
			} else if (this.touchSwipeOffset === -50) {
				this.fillDateToEdit();
			}
			this.deleteButtonFab = false;
			this.editButtonFab = false;
		},

		goToTodayDate() {
			const currentMonth = moment().format('YYYY-MM');
			this.selectedDay = moment().format('YYYY-MM-DD');

			if (this.selectedMonth !== currentMonth) {
				this.selectedMonth = moment().format('YYYY-MM');

				this.loading = false;
				this.fetchPlannedRegions(true).finally(() => {
					this.loading = false;
				})
			}
		}
	},

	created() {
		if (this.$route.query.date) {
			this.selectedDay = this.$route.query.date;
			this.selectedMonth = moment(this.$route.query.date).format('YYYY-MM');
		}

		this.loading = true;
		Promise.all([
			this.fetchPlannedRegions(true),
			this.$store.dispatch('regions/fetchAll'),
			this.$store.dispatch('regionPlans/fetchAll', { employeeId: this.self.employeeId }),
			this.$store.dispatch('configurations/fetchSystemConfigValue'),
		]).finally(() => {
			this.loading = false;
		})
	}
};
</script>

<style lang="scss">
#plans {
	overflow: hidden;
	.v-slide-group {
		&__prev, &__next {
			min-width: 30px;
		}
	}
	.planned-visit {
		&__container {
			display: flex;
			margin-bottom: .5rem;
			align-items: center;
			position: relative;
		}
		&__card {
			z-index: 1;
			flex-grow: 1;
			transition: all .4s ease;
		}
		&__action-btn {
			z-index: 0;
		}
	}
}

	.sale-system-add-fab {
		margin-bottom: 110px !important;
	}
</style>
